<template>
  <div class="text-with-filters" ref="root">
    <div class="rendered-text" v-html="rendered_text"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import {truncateMaxChars} from '@/utils/textUtils'
import InlineSelect from '@/components/IndicatorCards/parts/InlineSelect'

const timeScaleOptions = [{
    value: 'DAYS7',
    label: '7 días'
  },
  {
    value: 'DAYS30',
    label: '30 días'
  }]

const timeScaleMonthOptions = [{
    value: 'var_sector_online_month',
    label: 'el último mes'
  },
  {
    value: 'var_sector_online_3_months',
    label: 'los últimos 3 meses'
  },
  {
    value: 'var_sector_online_6_months',
    label: 'los últimos 6 meses'
  }]
  
export default {
  name: "TextWithFilters",
  props: ['textKey','textData','values', 'shareTextKey'],
  model:{
    prop: 'values',
    event: 'change'
  },
  data () {
    return {
      internalValues: this.values
    }
  },
  mounted () {
    this.updateSelects()
  },
  methods: {
    onFilterChange (def,value){
      if(!this.internalValues) this.internalValues = {}
      this.internalValues[def.id] = value
      // CUIDAO!!!! este "clone" es nuevo (de cuando hice lo del group_recovery que no recargue... (internalCurrentFilters))
      this.$emit('change',{...this.internalValues})
    },
    domFromPart (partId) {
      let def = this.textData.find((def)=>def.id === partId)
      if(!def) def = {id: partId, type: 'value'}
      if (partId === 'NODE_LABEL') def.value = truncateMaxChars(this.nodeInfo.value)
      else if (partId === 'timeScale') def.options = timeScaleOptions
      else if (partId === 'timeScaleMonth') def.options = timeScaleMonthOptions
      else if (partId.indexOf('sector')>=0) {
        def.options = [
          {
            value: '',
            label: this.t('all_sectors')
          }
        ]
        def.options = def.options.concat(this.nodeFilters.filters.find((d)=>d.id==='sector').data.map((o)=>({value:o,label:this.t(o)})))
      }
      else if (partId.indexOf('nationality')>=0) {
        def.options = [
          {
            value: '',
            label: this.t('all_nationality')
          }
        ]
        def.options = def.options.concat(this.nodeFilters.filters.find((d)=>d.id==='nationality').data.map((o)=>({value:o,label:this.t(o)})))
      } 
      else if (partId.indexOf('group')>=0) {
        def.options = [
          {
            value: 'commerce-sector-total',
            label: this.t('all_sectors')
          }
        ]
        def.options = def.options.concat(this.nodeFilters.filters.find((d)=>d.id==='group').data.map((o)=>({value:o,label:this.t(o)})))
      }

      if(!def) return 'NO_PART_DEF'

      if(def.type === 'value'){
        let spanClass = def.id == 'NODE_LABEL' ? 'node-label-text' : 'text-value'
        return `<span class='${spanClass}'>${def.value || ' -- '}${def.value && def.unit || ''}</span>`
      } else if(def.type==='select') {
        let optionValues
        // if(typeof def.options === "function") optionValues = def.options()
        // else optionValues = def.options

        optionValues = def.options
        /* //version orginal
        let options = optionValues.map((o)=>`<option value=${o.value}>${o.label}</option>`)
        return `<select id="${def.id}">${options}</select>`
        */
        let selectEl = new Vue({
          ...InlineSelect,
          parent: this,
          propsData: {
            id: def.id,
            options: optionValues
          }
        }).$mount()
        return selectEl.$el.outerHTML
      }
    },
    valueFromPart (partId) {
      let def = this.textData.find((def)=>def.id === partId)
      let textValue = ''
      if(!def) def = {id: partId, type: 'value'}
      if (partId === 'NODE_LABEL') textValue = truncateMaxChars(this.nodeInfo.value)
      else if (partId === 'timeScale') textValue = this.internalValues['timeScale'] ? timeScaleOptions.find(e => e.value == this.internalValues['timeScale']).label : timeScaleOptions[0].label
      else if (partId === 'timeScaleMonth') textValue = this.internalValues['timeScaleMonth'] ? timeScaleMonthOptions.find(e => e.value == this.internalValues['timeScaleMonth']).label : timeScaleMonthOptions[0].label
      else if (partId.indexOf('sector')>=0 || partId.indexOf('group')>=0) {
        textValue = this.t(this.internalValues[partId] || 'all_sectors').toLowerCase()
      }
      else if (partId.indexOf('nationality')>=0) {
        textValue = this.t(this.internalValues[partId] || 'all_nationality')
      }
      else if(def.type === 'value'){
        textValue= `${def.value || ' -- '}${def.value && def.unit || ''}`
      }

      if(!textValue){
        textValue = this.t(this.internalValues[partId])
      }

      if(!textValue) return 'NO_PART_DEF'
      return textValue
    },
    updateSelects () {
      this.$nextTick(()=>{
        this.textData.forEach((def)=>{
          let el = this.$refs.root.querySelector('#'+def.id)
          if(el){
            el.value = this.internalValues[def.id]

            // Update label
            let elLabel = this.$refs.root.querySelector('#'+def.id+'-label')
            let currentOption = def.options.find(e => e.value == el.value)
            // debugger
            if(elLabel && currentOption) {
              elLabel.innerHTML = currentOption.label
            }
          }
        })
        // DANGEROUS...
        this.textData.forEach((def)=>{
          let el = this.$refs.root.querySelector('#'+def.id)
          if(el){
            el.addEventListener('change',(e)=>{
              console.log('changed filter: ',def.id,'to value: ',e.target.value)
              this.onFilterChange(def,e.target.value)
            })
          }
        })
      })
    }
  },
  computed: {
    ...mapState(['nodeInfo','nodeFilters']),
    rendered_text () {
      let localeString = this.t(this.textKey)

      let matches = Array.from(localeString.matchAll(/(\$(\w*)\$)/g))
      let parts = matches.map((m)=>{
        return {
          str: m[2],
          replacement: this.domFromPart(m[2])
        }
      })
      parts.forEach((p)=>{
        localeString = localeString.replace('$'+p.str+'$',p.replacement)
      })
      return localeString
    },
    plain_text () {
      let localeString = this.t(this.shareTextKey || this.textKey)
      let matches = Array.from(localeString.matchAll(/(\$(\w*)\$)/g))
      let parts = matches.map((m)=>{
        return {
          str: m[2],
          replacement: this.valueFromPart(m[2])
        }
      })
      parts.forEach((p)=>{
        localeString = localeString.replace('$'+p.str+'$',p.replacement)
      })
      return localeString
    }
  },
  watch: {
    values(){
      this.internalValues = this.values
      // we have to "manullay set" as they are not in the template....
      this.$nextTick(()=>this.updateSelects())
    },
    rendered_text () {
      // DANGEROUS...
      this.updateSelects()
    }
  }
}
</script>

<style scoped lang="stylus">
.text-with-filters
  .rendered-text
    m-font-size(26,36)
    >>> select
      border: none;

    >>> .text-value
      color $bs-blue
  .mobile &
    .rendered-text
      m-font-size(20,30)
      width 90%
</style>